/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowminagehint3Inputs */

const en_rowminagehint3 = /** @type {(inputs: Rowminagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Younger people do not see the event in their feed.`)
};

const de_rowminagehint3 = /** @type {(inputs: Rowminagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jüngere sehen das Event nicht im Feed.`)
};

/**
* | output |
* | --- |
* | "Younger people do not see the event in their feed." |
*
* @param {Rowminagehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowminagehint3 = /** @type {((inputs?: Rowminagehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowminagehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowminagehint3(inputs)
	return de_rowminagehint3(inputs)
});
export { rowminagehint3 as "rowMinAgeHint" }